<script setup lang="ts">
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css' // Import Quill's default theme

// Define props for customization
const props = defineProps<{
  modelValue: string
  placeholder?: string
  theme?: 'snow' | 'bubble'
  toolbar?: boolean
}>()

const editorOptions = {
  placeholder: 'Start typing...',
  modules: {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link', 'image'],
    ],
  },
}
// Emit event for two-way binding
const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()
</script>

<template>
  <QuillEditor
    :content="modelValue"
    contentType="html"
    :theme="theme || 'snow'"
    :placeholder="placeholder || 'Start writing...'"
    :toolbar="toolbar !== false ? 'full' : false"
    @update:content="emit('update:modelValue', $event)"
    :options="editorOptions"
    editorStyle="height: 300px; width: 100%; border: 1px solid #ccc;"
  />
</template>
